import { createSelector } from 'reselect';

const cart_selector = createSelector(
  (state) => state.Cart,
  (cart) => [...new Set(cart)]
);
export default cart_selector;
